// src/hooks/useCountdown.js
//
// A live countdown to a real deadline (the welcome offer's promo.expires_at,
// mission 008 decision 008-02 §3): "hh:mm:ss" (hours past 24 kept), ticking
// every second, `urgent` under one hour, `done` at zero — then it stops. No
// deadline → nothing to count.

import { useEffect, useState } from 'react';

const HOUR = 3600_000;
const pad = (n) => String(n).padStart(2, '0');

/** milliseconds → "hh:mm:ss", never negative */
export function formatCountdown(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  return `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
}

export function useCountdown(expiresAt) {
  const target = expiresAt ? Date.parse(expiresAt) : NaN;
  const [now, setNow] = useState(() => Date.now());
  const live = Number.isFinite(target) && now < target;
  useEffect(() => {
    if (!Number.isFinite(target)) return undefined;
    setNow(Date.now());
    const t = window.setInterval(() => {
      const n = Date.now();
      setNow(n);
      if (n >= target) window.clearInterval(t);
    }, 1000);
    return () => window.clearInterval(t);
  }, [target]);
  if (!Number.isFinite(target)) return { text: null, remainingMs: 0, urgent: false, done: true };
  const remainingMs = Math.max(0, target - now);
  return { text: formatCountdown(remainingMs), remainingMs, urgent: live && remainingMs < HOUR, done: !live };
}
